import {
  INIT_URL,
  FETCH_QUEUE_MESSAGE_START,
  FETCH_QUEUE_MESSAGE_SUCCESS,
  FETCH_QUEUE_MESSAGE_ERROR,
  FETCH_QUEUE_MESSAGES_START,
  FETCH_QUEUE_MESSAGES_SUCCESS,
  FETCH_QUEUE_MESSAGES_ERROR,
  QUEUE_MESSAGE_LOADING,
  QUEUE_MESSAGES_LOADING,
  DELETE_QUEUE_MESSAGE_START,
  DELETE_QUEUE_MESSAGE_SUCCESS,
  DELETE_QUEUE_MESSAGE_ERROR,
  CHANGE_PAGE_LIMIT,
  CHANGE_PAGE,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  queue_messages: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalRecords: 1,
  },
  queue_message: {
    data: null,
    loading: false,
    error: null,
  },
  users: {
    data: [],
    loading: false,
    error: null,
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_URL: {
      return { ...state, initURL: action.payload };
    }

    case QUEUE_MESSAGE_LOADING: {
      return {
        ...state,
        queue_message: {
          ...state.queue_message,
          loading: action.payload,
        },
      };
    }

    case QUEUE_MESSAGES_LOADING: {
      return {
        ...state,
        queue_messages: {
          ...state.queue_messages,
          loading: action.payload,
        },
      };
    }

    case FETCH_QUEUE_MESSAGE_START: {
      return {
        ...state,
        queue_message: {
          ...state.queue_message,
          loading: true,
        },
      };
    }

    case FETCH_QUEUE_MESSAGE_SUCCESS: {
      return {
        ...state,
        queue_message: {
          ...state.queue_message,
          loading: false,
          data: action.payload,
        },
      };
    }

    case FETCH_QUEUE_MESSAGE_ERROR: {
      return {
        ...state,
        queue_message: {
          ...state.queue_message,
          loading: false,
          error: action.payload,
        },
      };
    }

    case FETCH_QUEUE_MESSAGES_START: {
      return {
        ...state,
        queue_messages: {
          ...state.queue_messages,
          loading: true,
        },
      };
    }

    case FETCH_QUEUE_MESSAGES_SUCCESS: {
      return {
        ...state,
        queue_messages: {
          ...state.queue_messages,
          loading: false,
          data: action.payload,
          currentPage: action.currentPage,
          totalRecords: action.totalRecords,
        },
      };
    }

    case FETCH_QUEUE_MESSAGES_ERROR: {
      return {
        ...state,
        queue_messages: {
          ...state.queue_messages,
          loading: false,
          error: action.payload,
        },
      };
    }

    case DELETE_QUEUE_MESSAGE_START: {
      return {
        ...state,
        queue_messages: {
          ...state.queue_messages,
          loading: true,
        },
      };
    }

    case DELETE_QUEUE_MESSAGE_SUCCESS: {
      return {
        ...state,
        queue_messages: {
          ...state.queue_messages,
          loading: false,
          data: state.queue_messages.data.filter((e) => e._id !== action.payload),
        },
      };
    }

    case DELETE_QUEUE_MESSAGE_ERROR: {
      return {
        ...state,
        queue_messages: {
          ...state.queue_messages,
          loading: false,
          error: action.payload,
        },
      };
    }

    case CHANGE_PAGE_LIMIT: {
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          pageSize: action.payload.pageSize,
        },
      };
    }

    case CHANGE_PAGE: {
      return {
        ...state,
        [action.payload.type]: {
          ...state[action.payload.type],
          currentPage: action.payload.currentPage,
        },
      };
    }

    default:
      return state;
  }
};
